import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'react-emotion';
import {
  EMAIL_ADDRESS,
  GITHUB_PROFILE,
  UPWORK_PROFILE,
  TWITTER_PROFILE,
  XING_PROFILE,
  mq,
} from '@sthzg/sthzgnet-base';
import StripedHeadline from '../StripedHeadline';
import logoXing from './assets/xing.png';
import logoUpwork from './assets/upwork.png';
import logoTwitter from './assets/twitter.png';
import logoGithub from './assets/github.png';
import logoEmail from './assets/email.png';

// ---
// Wrapper.
// ---
const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 30px;
  ${mq.small(css`
    flex-direction: row;
  `)};
`;

// ---
// Headline.
// ---
const BaseHeadline = ({ className }) => (
  <StripedHeadline className={className} tokens={["Why Don't We", 'Get In Contact?']} />
);
BaseHeadline.propTypes = {
  className: PropTypes.string.isRequired,
};

const Headline = styled(BaseHeadline)`
  width: 100%;
  ${mq.small(css`
    width: 44%;
  `)};
`;

// ---
// List.
// ---
const List = styled.ul`
  width: 100%;
  display: flex;
  justify-content: space-between;
  list-style-type: none;
  margin: 16px 0;
  padding: 0;
  ${mq.small(css`
    width: 56%;
    padding-left: 40px;
  `)};
`;

// ---
// Item.
// ---
const Item = styled.li`
  img {
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
  }
`;

const GetInContact = () => (
  <Wrapper>
    <Headline />
    <List>
      <Item>
        <a href={`mailto:${EMAIL_ADDRESS}`}>
          <img src={logoEmail} alt="via Email" height={37} />
        </a>
      </Item>
      <Item>
        <a href={UPWORK_PROFILE}>
          <img src={logoUpwork} alt="via Upwork" height={40} />
        </a>
      </Item>
      <Item>
        <a href={GITHUB_PROFILE}>
          <img src={logoGithub} alt="via Github" height={40} />
        </a>
      </Item>
      <Item>
        <a href={XING_PROFILE}>
          <img src={logoXing} alt="via Xing" height={40} />
        </a>
      </Item>
      <Item>
        <a href={TWITTER_PROFILE}>
          <img src={logoTwitter} alt="via Twitter" height={40} />
        </a>
      </Item>
    </List>
  </Wrapper>
);

export default GetInContact;



// WEBPACK FOOTER //
// ../sthzgnet-branding/lib/GetInContact/GetInContact.jsx